import React, { useState, useEffect } from "react";
import axios from "axios";
import TopMenu from "./TopMenu";
import Loader from "../components/Sidebar/Preloader";
import SparklineChart1 from "../charts/SparklinkCharts1";
import SparklineChart2 from "../charts/SparklinkCharts2";
import SparklineChart3 from "../charts/SparklinkCharts3";
import SparklineChart4 from "../charts/SparklinkCharts4";
import LineChart from "../charts/LineChart";
import BudgetsAndSales from "../charts/BudgetsAndSales";
import Footer from "./Footer";

export default function Dashboard() {
  const BASE_URL = "https://news-24-7-backend.onrender.com";
  // const BASE_URL = 'http://localhost:3001';
  const [datas, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetch = async () => {
      await fetchAllData();
    };
    fetch();
    const timer = setTimeout(() => {
      setLoading(false);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);
  const fetchAllData = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/data`);
      if (response) {
        setData(response.data);
      } else {
        console.log("No Records found");
      }
    } catch (error) {
      console.log("Error fetching data:");
    }
  };
  return (
    <main className="dashBoardStyleMain">
      <TopMenu data={0} />
      <div className="newsDiv">
        <div className="chartsDashboard">
          {loading ? (
            <Loader />
          ) : (
            <div className="main_dasbord">
              <div className="box_main">
                <div className="box box1">
                  <SparklineChart1 data={datas} />
                </div>
                <div className="box box2">
                  <SparklineChart2 data={datas} />
                </div>
                <div className="box box3">
                  <SparklineChart3 data={datas} />
                </div>
                <div className="box box4">
                  <SparklineChart4 data={datas} />
                </div>
              </div>
              <div className="parent_box">
                <div className="child child1">
                  <LineChart data={datas} />
                </div>
                <div className="child child2">
                  <BudgetsAndSales data={datas} />
                </div>
              </div>
              <Footer/>
            </div>
          )}
        </div>
      </div>
    </main>
  );
}
